import { MainMenuItemTP } from 'modules/app/components/user-main-menu/inner/MainMenuItemTP'

/**
 * MENU PRINCIPAL: Itens.
 *
 * @author renatofs
 */
export const MENU_OPTIONS_BOTTOM: MainMenuItemTP[] = []
